import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // remove the fragment
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Signed in as ${data.email}`);
        nav("/app", { replace: true });
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50" data-testid="auth-callback">
      <div className="text-sm text-zinc-500 font-mono">Completing Google sign-in…</div>
    </div>
  );
}
